import $http from '@/api/index'
import axios from 'axios'
//登录
export function WebPageLogin(Code, Password) {
  let getUrl = {
    method: 'POST',
    url: `User/CheckLogin?username=${Code}&password=${Password}`,
    requestType: 1,
  }
  let params = {
  }
  return $http(getUrl, params)
}
/**
 * @description 根据code获取用户信息
 * @constructor
 */
export function GetSysUserByCode(Code) {
  let getUrl = {
    method: 'GET',
    url: 'user/GetSysUserByCode',
    requestType: 2,
  }
  let params = {
    "Code": Code
  }
  return $http(getUrl, params)
}
export function loginByUsername(username, password, code) {
  const options = {
    method: 'POST',
    url: 'login/CheckLogin',
    requestType: 1
  }
  const params = {
    username,
    password,
    code
  }
  return $http(options, params)
}

export function logout() {
  const options = {
    method: 'get',
    url: 'login/OutLogin',
    requestType: 1
  }
  const params = {

  }
  return $http(options, params)
}

export function userLogin(code) {
  let options = {
    method: 'GET',
    url: 'user/userLogin',
    requestType: 1
  }
  let params = {
    code: code
  };
  console.log(options)
  console.log(params)
  return $http(options, params)
}

export function getUserInfo(token) {
  const options = {
    method: 'get',
    url: '/user/info',
    requestType: 1
  }
  const params = {
    token
  }
  return $http(options, params)
}

export function getCurrentUserInfo() {
  const options = {
    method: 'get',
    url: '/user/currentinfo',
    requestType: 1
  }
  const params = {
  }
  return $http(options, params)
}

export function postCurrentUserInfo(user) {
  const options = {
    method: 'POST',
    url: '/user/PostInfo',
    requestType: 1
  }
  const params = {
    user
  }
  return $http(options, params)
}

export function getRelName(id) {
  let options = {
    method: 'GET',
    url: 'User/GetContactByID',
    requestType: 2
  }
  let params = {
    ContactID: id
  }
  return $http(options, params)
}

// 单个人员注册信息
export function registerUserInfo(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/RegisterOrUpdateEmergencyInfo',
    requestType: 11,
    isJsonData: true
  }
  return $http(options, params)
}

// 批量注册人员校验
export function VerifyBatchRegisterEmergencyInfo(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/VerifyBatchRegisterEmergencyInfo',
    requestType: 11,
    isJsonData: true
  }
  return $http(options, params)
}
// 单个注册人员校验
export function VerifyRegisterEmergencyInfo(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/VerifyRegisterEmergencyInfo',
    requestType: 11,
    isJsonData: true
  }
  return $http(options, params)
}

// 批量注册提交
export function BatchRegisterEmergencyInfoList(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/BatchRegisterEmergencyInfoList',
    requestType: 11,
    isJsonData: true
  }
  return $http(options, params)
}
// 根据任务ID获取对应的注册类型 0单个 1 批量 -10 获取数据异常
export function GetRegisterTypeByTaskId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetRegisterTypeByTaskId',
    requestType: 11
  }
  return $http(options, params)
}
// 根据任务ID 获取对应的注册信息
export function GetEmergencyUserInfoByTaskId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetEmergencyUserInfoByTaskId',
    requestType: 11
  }
  return $http(options, params)
}
// 根据任务ID获取多人注册审批
// /api/emergencybasedata/GetUserInportTemplateInfoResultCount
export function GetUserInportTemplateInfoResultCount(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/GetUserInportTemplateInfoResultCount',
    requestType: 11,
    isJsonData: true,
    isParams: true,
  }
  return $http(options, params)
}

